<template>
  <div id="inbox">
    <title title="Vue Mail"></title>
  </div>
</template>

<script>
import Title from './components/Title'

export default {
  components: {
    Title
  }
}
</script>



/** WEBPACK FOOTER **
 ** Root.vue?d70ee674
 **/